import { Stack } from '@mui/material';
import KpiComponent from '@/components/Base/KpiComponent';
import type { KpisResponse } from '../types';

interface Props {
  data: KpisResponse | undefined;
}

const ScorePedagogicoKpis: React.FC<Props> = ({ data }) => {
  return (
    <Stack flexDirection="row" gap="8px" mb={2} flexWrap="wrap">
      <KpiComponent
        title="Média Geral"
        bgColor="#FFFFFF"
        border={'2px solid #ECEEF7'}
        borderRadius={'6px'}
        value={data ? data.media_geral.toFixed(1) : '-'}
        style={{ width: '160px' }}
        tooltipText="Média geral de todas as notas no escopo selecionado."
      />

      <KpiComponent
        title="Disciplina com Maior Deficiência"
        bgColor="#FFFFFF"
        border={'2px solid #ECEEF7'}
        borderRadius={'6px'}
        value={data?.pior_disciplina ?? '-'}
        style={{ width: '160px' }}
        tooltipText="Disciplina com a menor média entre todas as turmas filtradas."
      />

      <KpiComponent
        title="Turma com Maior Dificuldade"
        bgColor="#FFFFFF"
        border={'2px solid #ECEEF7'}
        borderRadius={'6px'}
        value={data?.pior_turma ?? '-'}
        style={{ width: '160px' }}
        tooltipText="Turma com a menor média geral entre todas as disciplinas."
      />

      <KpiComponent
        title="Alunos Abaixo da Média"
        bgColor="#FFFFFF"
        border={'2px solid #ECEEF7'}
        borderRadius={'6px'}
        value={data ? String(data.qtd_abaixo_media) : '-'}
        style={{ width: '160px' }}
        tooltipText="Quantidade de alunos com nota abaixo de 6.0."
      />
    </Stack>
  );
};

export default ScorePedagogicoKpis;
